"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.coinsToValue = coinsToValue;
var _Core = _interopRequireDefault(require("../dragon/store/Core"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * Get the actual value, as a number of the bet. not as a string. usefull when operation based on value is needed such as determine fractions.
 * 
 * @param coins 
 * @param denom 
 * @returns 
 */
function coinsToValue(coins, denom) {
  if (denom == undefined) {
    var state = _Core["default"].getState();
    denom = state.bet.denomination;
  }
  return coins * denom;
}
//# sourceMappingURL=coinsToValue.js.map